import React from "react";
import { Link } from "gatsby";
import { 
  DetailWrapper, 
  DetailSection, 
  DetailHead, 
  DetailSubhead, 
  SubheadingWrap, 
  Description, 
  DescriptionCalc, 
  HeadingWrap 
} from "../styles/DetailBreakdown.styled"

import { ITIcon, ProductivityIcon, ApprovalsIcon } from "../../../utils/IconsList"

const DetailBreakdown = ({ 
  annualApprovalsSavings, 
  annualProductivitySavings, 
  annualItSavings, 
  prodHoursSaved, 
  ticketsPerEmp 
}) => (
  <DetailWrapper>
    <DetailSection>
      <HeadingWrap>
        <ApprovalsIcon />
        <DetailHead>Streamlining Approvals</DetailHead>
      </HeadingWrap>
      <DetailSubhead>{annualApprovalsSavings} Saved Per Year</DetailSubhead>
      <Description>
        <p>Workgrid dramatically reduces the amount of time to complete approvals. From timesheet approvals to expense reports, Workgrid saves employees a minimum of 45 seconds per approval.</p>
        <DescriptionCalc>How This is Calculated</DescriptionCalc>
        <p>This number was calculated by taking the average number of approvals for an organization of your size and multiplying it by the average time saved from customer data.</p>
      </Description>
    </DetailSection>
    <DetailSection>
      <HeadingWrap>
        <ProductivityIcon/>
        <DetailHead>Reduced Time to View Information</DetailHead>
      </HeadingWrap>
      <SubheadingWrap>
        <DetailSubhead>{annualProductivitySavings} Saved Per Year</DetailSubhead>
        <DetailSubhead>{prodHoursSaved} Hours Saved Per Week</DetailSubhead>
      </SubheadingWrap>
      <Description>
        <p>On average, Workgrid reduces the time to find information by 60% by instantly surfacing data from third-party systems and knowledge sources. From HR policies to time off balances, employees can find it all through the Workgrid AI Assistant.</p>
        <p>On average, for a company your size, you’d save employees a minimum of 5 minutes per week with just a few use cases. Imagine the possibilities if you had various use cases implemented across multiple departments!</p>
        <DescriptionCalc>How This is Calculated</DescriptionCalc>
        <p>This number is calculated by taking the average number of minutes per week saved per employee (based on customer data) and multiplying it by the total number of employees at your company.</p>
      </Description>
    </DetailSection>
    <DetailSection>
      <HeadingWrap>
        <ITIcon />
        <DetailHead>Reduction in Time to Submit Tickets</DetailHead>
      </HeadingWrap>
      <SubheadingWrap>
        <DetailSubhead>93% Reduction in Time to Submit Tickets</DetailSubhead>
        <DetailSubhead>{annualItSavings} Cost Savings</DetailSubhead>
      </SubheadingWrap>
      <Description>
        <p>On average, customers using the Workgrid AI Assistant to submit tickets (e.g. IT or HR Help Desk Tickets), see a 93% reduction in the handling time of tickets. This correlates to significant cost savings for your IT or HR department and a significant reduction in friction for your employees.</p>
        <DescriptionCalc>How This is Calculated</DescriptionCalc>
        <p>The number is calculated by taking the average handling time saved, per ticket and multiplying it by the number of tickets handled at your organization, we then multiply that by the average handling cost per ticket.</p>
        <p>Based on a company of your size, we used an estimated number of tickets handled per year. <a href="https://www.thinkhdi.com/~/media/HDICorp/Files/Library-Archive/Insider%20Articles/cost-per-ticket-per-user.pdf">Research shows {ticketsPerEmp} tickets are created per month per employee.</a> According to Gartner, the average cost per IT Support ticket ranges from, $15-$35/ticket.</p>
      </Description>
    </DetailSection>
  </DetailWrapper>
)

export default DetailBreakdown
